/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { IconName } from 'common/components/controls/icon';
// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import { POPOVER_NAME } from 'components/popovers/boards-menu/boards-menu';
// eslint-disable-next-line no-restricted-imports
import { ScreenBreakpoints } from 'components/responsive';
// eslint-disable-next-line no-restricted-imports
import Keybindings, { Key } from 'components/shared/keybindings';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
// eslint-disable-next-line no-restricted-imports
import {
  setBoardsMenuScrollPosition,
  showPopover,
  State,
  toggleBoardsMenu,
} from 'modules';
import React from 'react';
import Media from 'react-media';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
// eslint-disable-next-line no-restricted-imports
import {
  areAnyPopoversOrOverlaysCurrentlyOpen,
  isPopoverShown,
} from 'selectors';
import HeaderButton from './button';
import styles from './header.less';

interface Props {
  isBoardsMenuOpen: boolean;
  onClick(): void;
  onHotkey(): void;
  activeOverlays: boolean;
}

// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
const format = forTemplate('boards_sidebar');

class HeaderBoardMenuButton extends React.Component<Props> {
  onHeaderButtonClick = () => {
    const { isBoardsMenuOpen, onClick } = this.props;

    onClick();

    if (!isBoardsMenuOpen) {
      Analytics.trackUE({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.BOARDS_MENU,
        method: 'by clicking boards button in header',
      });
    }
  };

  onBoardOpenKeyPress = (e: React.KeyboardEvent<HTMLElement>) => {
    const { isBoardsMenuOpen, onHotkey, activeOverlays } = this.props;

    if (!isBoardsMenuOpen && !activeOverlays) {
      e.preventDefault();
      onHotkey();

      Analytics.trackUE({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.BOARDS_MENU,
        method: 'by using boards menu shortcut',
      });
    }
  };

  keybindings = {
    [Key.b]: {
      callback: this.onBoardOpenKeyPress,
      isGlobal: true,
    },
  };

  render() {
    return (
      <HeaderButton
        icon={IconName.Board}
        onClick={this.onHeaderButtonClick}
        testId={HeaderTestIds.BoardsMenuButton}
      >
        <Keybindings keybindings={this.keybindings}>
          <Media query={ScreenBreakpoints.MediumMin}>
            {(matches: boolean) => (
              <span
                className={classNames(
                  styles.boardsButtonText,
                  !matches && styles.boardsButtonTextCollapsed,
                )}
              >
                {format('boards')}
              </span>
            )}
          </Media>
        </Keybindings>
      </HeaderButton>
    );
  }
}

class HeaderBoardMenuButtonContainer extends React.Component<Props> {
  render() {
    return <HeaderBoardMenuButton {...this.props} />;
  }
}

const mapStateToProps = (state: State) => {
  return {
    isBoardsMenuOpen: isPopoverShown(state, POPOVER_NAME),
    activeOverlays: areAnyPopoversOrOverlaysCurrentlyOpen(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<State>) => {
  return {
    onClick() {
      dispatch(setBoardsMenuScrollPosition(0));
      dispatch(showPopover({ name: POPOVER_NAME }));
      dispatch(toggleBoardsMenu());
    },
    onHotkey() {
      dispatch(showPopover({ name: POPOVER_NAME }));
      dispatch(toggleBoardsMenu());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderBoardMenuButtonContainer);



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/board-menu-button.tsx